import { EContractType } from '@/packages/api-models/common/json_query';

import { type IContractTypeOption } from '../types';

export const RENT_CONTRACT_TYPE_OPTIONS: IContractTypeOption[] = [
  { label: 'Неважно', value: null },
  { label: 'Прямая аренда', value: EContractType.DirectRent },
  { label: 'Субаренда', value: EContractType.SubRent },
];

export const SALE_CONTRACT_TYPE_OPTIONS: IContractTypeOption[] = [
  { label: 'Неважно', value: null },
  { label: 'Продажа объекта', value: EContractType.ObjSale },
  { label: 'Переуступка прав аренды', value: EContractType.PermTransfer },
];
